import { apiBaseUrl } from "@/constants/index"
import { customerSupportUrl, pinCodeUrl, submitFeedbackUrl } from "./constants"
import { getAccessToken } from "@/utils/helper"
import { apim } from "@/constants/api"

export const postCustomerSupport = async body => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.post(
        `${apiBaseUrl}${customerSupportUrl}`,
        body
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getLocationPincode = async pincode => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.get(
        `${apiBaseUrl}${pinCodeUrl}/${pincode}`
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const submitFeedback = async payload => {
  let accessToken = null
  accessToken = getAccessToken()?.token
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.post(
        `${apiBaseUrl}${submitFeedbackUrl}`,
        payload
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}
